<azjs-network-state
  [messages]="{ offline: offlineText, online: onlineText }"
></azjs-network-state>
